import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';

export const Footer = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.footer}>
      <div className={styles.links}>
        <a href="https://loona.app/terms">{t('termsOfUse')}</a>
        <a href="https://loona.app/privacy">{t('privacyPolicy')}</a>
      </div>
      <span className={styles.copyright}>
        © {new Date().getFullYear()} {t('rightsReserved')}
      </span>
    </div>
  );
};
